import React from 'react';
import PropTypes from 'prop-types';

import List from './List';

const ThirdLevelMenu = ({ settings, showSubList, thirdLevelIndex, fourthLevelIndex }) => {
    // create list for render and assign className for each el based on current index
    let list = [];

    Object.values(settings).forEach((value, index) => {
      let itemClassName = 'List-item ';
      value.disabled ? (itemClassName += ' disabled') : (itemClassName += '');
      if (showSubList === true) {
          index === thirdLevelIndex ? (itemClassName += ' List-item-with-sublist') : (itemClassName += ' hidden');
      } else {
          index === thirdLevelIndex ? (itemClassName += ' List-item-active') : (itemClassName += '');
      }
      value.className = itemClassName;
      list.push(value)
    });

    const rowAmount = 8;

    return (
      <List
        list={list}
        listItemIndex={thirdLevelIndex}
        subListItemIndex={fourthLevelIndex}
        showSubList={showSubList}
        rowAmount={rowAmount}
      />
    )
    
};
  
ThirdLevelMenu.propTypes = {
    settings: PropTypes.objectOf(PropTypes.object),
    thirdLevelIndex: PropTypes.number,
    fourthLevelIndex: PropTypes.number,
    showSubList: PropTypes.bool.isRequired,
};

export default ThirdLevelMenu;